import type { RestCreateIntegration, RestIntegration, RestUpdateIntegration } from "@KassaroAB/shared/types/integrations/integration";
import type { z } from "zod";
import { VivaIsvFeeScheme } from "@KassaroAB/shared/types/paymentMethods/vivaIsvConfig";
import { api } from "../utils/api";
import type { ChainId, IntegrationId, StoreId } from "@KassaroAB/shared/types/ids";

export type RestCreateVivaIntegrationBody = {
  name: string;
  isvFee: z.infer<typeof VivaIsvFeeScheme>;
  merchantEmail: string;
};

export const getIntegrationsApi = async (
  chainId: ChainId,
): Promise<RestIntegration[]> => {
  return api.get(`chains/${chainId}/integrations`);
};

export const getIntegrationApi = async (
  chainId: ChainId,
  integrationId: IntegrationId,
): Promise<RestIntegration> => {
  return api.get(`chains/${chainId}/integrations/${integrationId}`);
};

export const createIntegrationApi = async (
  chainId: ChainId,
  integration: RestCreateIntegration,
  storeId?: StoreId,
): Promise<RestIntegration> => {
  const params = new URLSearchParams();
  if (storeId) {
    params.set("storeId", storeId);
  }
  const query = params.toString();
  return api.post(
    `chains/${chainId}/integrations${query ? `?${query}` : ""}`,
    integration,
  );
};

export type RestCreateVivaIntegrationResponse = {
  integration: RestIntegration;
  onboardingLink: string;
};

export const createVivaIntegrationApi = async (
  chainId: ChainId,
  body: RestCreateVivaIntegrationBody,
): Promise<RestCreateVivaIntegrationResponse> => {
  return api.post(`chains/${chainId}/integrations/viva`, body);
};

export const updateIntegrationApi = async (
  chainId: ChainId,
  integrationId: IntegrationId,
  integration: Partial<RestUpdateIntegration>,
): Promise<RestIntegration> => {
  return api.put(`chains/${chainId}/integrations/${integrationId}`, integration);
};

export const deleteIntegrationApi = async (
  chainId: ChainId,
  integrationId: IntegrationId,
): Promise<void> => {
  return api.delete(`chains/${chainId}/integrations/${integrationId}`);
};
